import _jsx from '@babel/runtime/helpers/esm/jsx';
import { useMemo, memo } from 'react';
import Header from '@dbh/header';
import withLegacyAdapter from '@dbh/legacy-adapter';
import { FOOTER_COMPONENTS, useOrderedNavigationMenuReferencesToRender } from '@dbh/footer';
import 'invariant';
import 'common-tags';
import Banners from '@dbh/banners';
import { AppDownloadSection } from '@dbh/app-download-section';
import FormNewsletterDirectSignup from '@dbh/newsletter-signup-form';
import TilesSection from '@dbh/tiles-section';
import { jsxs, Fragment } from 'react/jsx-runtime';

const HOME_PAGE_COMPONENTS=[...FOOTER_COMPONENTS,Banners,TilesSection,AppDownloadSection,FormNewsletterDirectSignup];const HOME_PAGE_WEBCONTROLS_REFERENCES_TO_COMPONENT=HOME_PAGE_COMPONENTS.reduce((a,b)=>{const c=a,{dbhNavigationMenuReference:d}=b;return c[d]=b,c},{});

const useSectionsToBeRenderedInHomePage=()=>{const[a]=useOrderedNavigationMenuReferencesToRender(),b=useMemo(()=>{const b=a.reduce((a,b)=>{const c=HOME_PAGE_WEBCONTROLS_REFERENCES_TO_COMPONENT[b];return c&&a.push(/*#__PURE__*/_jsx(c,{},b)),a},[]);return b},[a]);return b};var useSectionsToBeRenderedInHomePage$1 = useSectionsToBeRenderedInHomePage;

var _Header;const HomePage=/*#__PURE__*/memo(()=>{const a=useSectionsToBeRenderedInHomePage$1();return/*#__PURE__*/jsxs(Fragment,{children:[_Header||(_Header=/*#__PURE__*/_jsx(Header,{})),a]})});HomePage.displayName="HomePage";var component = withLegacyAdapter(HomePage);

export { component as default };
